import { CustomValidation } from './CustomValidation';
import { InputType } from '../Enums/InputType';
import { EnglishArabicDTO } from './EnglishArabicDTO';
import { ControlLayout } from '../Enums/ControlLayout';
import { Misc } from '../Enums/Misc';
import { Style } from '../Enums/Style';
import { FontSize } from '../Enums/FontSize';
import { Para } from '../Enums/Para';
import { Insert } from '../Enums/Insert';
import { LanguageMode } from '../Enums/LanguageMode';

export class MultiLingualHtmlEditorOptions {
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]
/**To Set Value To MultipleLanguageText with Object From Type "EnglishArabicDTO" */
  Value: EnglishArabicDTO = new EnglishArabicDTO();
   /**  Represent value of the Label*/
   LabelValue: string;
    /**  Represent Key of the label*/
    ArabicLabelKey:string
    /**  Represent Key of the label*/
    EnglishLabelKey:string
  /**  Represent value of the ArabicLabel*/
  ArabicLabelValue: string;
  /**  Represent value of the EnglishLabel*/
  EnglishLabelValue: string;
    /**  Represent value of the LabelDescription show under textbox*/
    LabelDescription: string;
  /**  Represent value of the ArabicLabelDescription show under MultipleLanguageText*/
  ArabicLabelDescription: string;
  /**  Represent value of the EnglishLabelDescription show under MultipleLanguageText*/
  EnglishLabelDescription: string;
  /**
* Represent Name Of Form Control
*/
  Name: string;
  Type: InputType;
  /**
* Represent ArabicPlaceholder Of Form Control
*/
  ArabicPlaceholder: string;
  /**
* Represent EngilshPlaceholder Of Form Control
*/
  EngilshPlaceholder: string;
  /**
*   Represent classes to Arabic textbox that allow us to select the MultipleLanguageText by jquery or javascript 
*/

  ExtraClasses_AR: string;
  /**
*   Represent classes to English textbox that allow us to select the MultipleLanguageText by jquery or javascript 
*/

  ExtraClasses_EN: string;
 
  /**  to set type of view  if MultipleLanguageText is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
  /**Set the MinLength of characters In MultipleLanguageText  */
  MinLength: number;
  //** Set the MaxLength of characters In MultipleLanguageText */
  MaxLength: number;
  //** Set the MaxWordCount of characters In MultipleLanguageText */
  MaxWordCount: number;
  /**  trim input on change  */
  TrimTextOnChange: boolean
  /** add button to for coping to clipboard */
  EnableCopyToClipboard: boolean
  /**
* Display "*" beside the label 
* if ForceAsterisk=true and IsRequired=True his display "*" ,
* if if ForceAsterisk=false and IsRequired=false this remove "*",
*if ForceAsterisk=false and IsRequired=True this display "*" , 
*/
  ShowAsterisk: boolean
  /** Ability to set  MultipleLanguageText required */
  IsRequired: boolean;
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean;
  /** Ability to display or hide the EngilshField of MultipleLanguageText */
  IsHideEngilshFields: boolean;
  /** Ability to display or hide the ArabicField of MultipleLanguageText */
  IsHideArabicFields: boolean;
  /** Ability to display or hide the EngilshLabel of MultipleLanguageText */
  IsHideEngilshLabel: boolean;
  /** Ability to display or hide the ArabicLable of MultipleLanguageText */
  IsHideArabicLable: boolean;
  /** Set Height For  */
  Height: number=150
  
   /** Set List of Misc like codeview Or undo Or redo  */
   ToolsList_Misc?: Misc[];
   /** Set List of Style like bold Or italic Or underline Or clear  */
   ToolsList_Style?: Style[];
   /** Set List of FontSize like fontname Or fontsize Or color   */
   ToolsList_FontSize?: FontSize[];
   /** Set List of Para like style Or ul Or ol Or paragraph Or height   */
   ToolsList_Para?: Para[];
   /** Set List of Insert like table Or picture Or link Or video Or hr   */
   ToolsList_Insert?: Insert[];
     /**To Set LanguageMode To MultipleLanguageText */
     LanguageMode:LanguageMode=LanguageMode.Both_Languages_are_visible;

}
